// extracted by mini-css-extract-plugin
module.exports = {"switcher":"styles_switcher__3lUV5","switcherBg":"styles_switcherBg__3mq3c","overflow":"styles_overflow__3WTOV","button":"styles_button__3FSeY","active":"styles_active__18Jwz"};